import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dot-planet-path-icon_62487cd3164147bdc8635154ee0e9ceb",
  "use": "dot-planet-path-icon_62487cd3164147bdc8635154ee0e9ceb-usage",
  "viewBox": "0 0 22 138",
  "content": "<symbol viewBox=\"0 0 22 138\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"dot-planet-path-icon_62487cd3164147bdc8635154ee0e9ceb\">\n<path d=\"M21 1L13.3812 18.6997C-2.84777 56.4021 -3.16552 99.0601 12.5 137V137\" stroke=\"#55586B\" stroke-dasharray=\"5 8\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol